import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const HERO_IMAGE =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/tfs6fj8z_8adaff9c-1f38-4bdf-9dc5-f60b524df658.png";

export const EconomicsHero = () => {
  const navigate = useNavigate();

  return (
    <section
      data-testid="economics-hero-section"
      className="bg-baseLight px-6 pt-[130px] pb-[30px] sm:pt-[150px] sm:pb-[40px] lg:px-12 lg:pt-[190px] lg:pb-[70px]"
    >
      <div className="lg:mx-auto lg:max-w-[1280px]">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-7"
          >
            <span data-testid="economics-hero-eyebrow" className="text-sm font-medium text-teal">
              ECONOMICS
            </span>
            <h1
              data-testid="economics-hero-headline"
              className="mt-3 font-heading text-[34px] font-semibold leading-[1.15] text-ink sm:text-[46px] lg:text-[55px]"
            >
              Energy resilience
              <br className="sm:hidden" /> has
              <br className="hidden lg:block" /> to add up
            </h1>
            <p
              data-testid="economics-hero-text"
              className="mt-[32px] lg:mt-6 max-w-xl text-[15px] leading-relaxed text-inkSoft"
            >
              A hybrid energy system should make operational and financial sense. We evaluate
              diesel dependence, grid constraints, renewable energy utilization, backup
              requirements and long-term costs to understand whether a proposed system is worth
              pursuing.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-x-7 gap-y-4">
              <button
                type="button"
                data-testid="economics-hero-cta-primary"
                onClick={() => navigate("/#contact")}
                className="inline-flex h-11 items-center bg-teal text-white text-sm font-medium rounded-full px-6 hover:bg-tealHover transition-all duration-300 hover:-translate-y-0.5"
              >
                Request an Energy Assessment
              </button>
              <Link
                to="/solutions"
                data-testid="economics-hero-cta-secondary"
                className="group inline-flex items-center gap-1.5 text-sm text-inkSoft hover:text-teal transition-colors duration-300"
              >
                <span className="underline decoration-borderSubtle group-hover:decoration-teal/60 transition-colors duration-300">
                  Explore the Solutions
                </span>
                <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-0.5" />
              </Link>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-5"
          >
            <div
              data-testid="economics-hero-visual"
              className="h-[280px] overflow-hidden rounded-3xl sm:h-[340px] lg:h-[374px]"
            >
              <img
                src={HERO_IMAGE}
                alt="Agricultural facility with rooftop solar infrastructure"
                className="h-full w-full object-cover object-center"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
